/* PFS Collection Swatches - Standalone v9 */
(function(){

  // ─── EFL variation-aware cards (2026-07-09; replaces "ungroup mode") ─────
  // Cards stay family-grouped everywhere. When the customer has expressed a
  // variation preference — a Size/Color facet value on a PLP, or size/finish
  // words in a search query — each family card opens on the matching member
  // instead of the family default. Filtered PLPs still force A→Z sort.

  function eflFiltersActive() {
    var p = new URLSearchParams(location.search);
    var found = false;
    p.forEach(function(_v, k) { if (k.indexOf('filter.') === 0) found = true; });
    return found;
  }

  // Auto-sort handling on PLPs:
  //   - filter active + no sort_by → redirect to sort_by=title-ascending (A→Z)
  //   - no filter + sort_by present → strip sort_by so collection default
  //     ("Featured" / manual sort) takes over. This snaps the page back to
  //     Featured when a customer removes their filters.
  // location.replace prevents these rewrites from polluting browser history.
  (function eflAutoSort() {
    try {
      var params = new URLSearchParams(location.search);
      var filterActive = eflFiltersActive();
      var hasSort = params.has('sort_by');
      if (filterActive && !hasSort) {
        params.set('sort_by', 'title-ascending');
        location.replace(location.pathname + '?' + params.toString() + location.hash);
        return;
      }
      if (!filterActive && hasSort) {
        params.delete('sort_by');
        var qs = params.toString();
        location.replace(location.pathname + (qs ? '?' + qs : '') + location.hash);
        return;
      }
    } catch (e) {}
  })();

  var FAMILIES_URL = "//cdn.shopify.com/s/files/1/0750/1817/4697/t/14/assets/families.json?v=1793776405";
  // Per-collection {s: styles, i: items} counts, generated nightly by
  // collection_counts (maintenance worker step; python fallback
  // shopify/scripts/collection_counts.py). The generator patches this URL
  // after each upload, same as FAMILIES_URL above.
  var COUNTS_URL = "//cdn.shopify.com/s/files/1/0750/1817/4697/t/14/assets/collection_counts.json?v=1793777675";

  var FINISH_HEX = {'Black':'#000','Matte Black':'#1a1a1a','Chrome':'#C0C0C0','Polished Chrome':'#D4D4D4','Satin Gold':'#bd945b','Gold':'#D4AF37','Brushed Gold':'#C5A55A','Polished Gold':'#E6BE5A','French Gold':'#C2A569','Vintage Gold':'#A67B3D','Honey Gold':'#DAA520','Stain Gold':'#bd945b','Golden Iron':'#9C7A3C','Golden Teak':'#B8860B','Golden black':'#1a1a1a','Silver':'#BEBEBE','Silver Leaf':'#C0C0C0','Vintage Silver':'#A8A8A8','Vintage Silver Leaf':'#B0B0B0','Antique Silver':'#A8A8A8','Antique Silver Leaf':'#B0B0B0','Hand Rubbed Antique Silver':'#A8A8A8','Hand rubbed Antique Silver':'#A8A8A8','Brass':'#B5A642','Antique Brass':'#8B7355','Light Antique Brass':'#8B7355','Light Antique Brass and Flat Black':'#7A6A4F','Light Antique Brass And Flat Black':'#7A6A4F','Burnished Brass':'#B5A642','Brushed Brass and Black':'#8B7355','Manual Brass':'#B5A642','Bronze':'#6D5C41','Dark Bronze':'#4A3728','Vintage Bronze':'#6D5C41','Antique Bronze':'#6D5C41','Oil Rubbed Bronze':'#3B2A1A','Oil rubbed bronze':'#3B2A1A','Polished Nickel':'#B8B8B8','Polished nickel':'#B8B8B8','Satin Nickel':'#9C9C9C','Brushed Nickel':'#A0A0A0','Burnished Nickel':'#8A8A7A','Vintage Nickel':'#8A8A7A','Nickel':'#B0B0B0','Pewter':'#96A0A0','Gun Metal':'#52575D','Copper':'#B87333','Aluminum':'#A9A9A9','Stainless Steel':'#C0C0C0','Aged Iron':'#555','Rose Gold':'#B76E79','Champagne':'#F7E7CE','Flat Black':'#1a1a1a','Flat Black (matte)':'#1a1a1a','Rustic Intent':'#7A5C3C','Rustic Grey':'#8B8378','Satin Dark Grey':'#555','Dark Grey':'#555','Weather Brass':'#7A6A4F','Black and Gold':'#1a1a1a','Black And Gold':'#1a1a1a','Black and Brass':'#1a1a1a','Black and White':'#1a1a1a','Black and Clear':'#1a1a1a','Black and Coffee':'#1a1a1a','Black and Frosted White':'#1a1a1a','Black Paint':'#1a1a1a','Matte Black and Brass':'#1a1a1a','Brass and Black':'#B5A642','Brass and Clear':'#B5A642','Brass and Dark Brown':'#B5A642','Brass and Frosted White':'#B5A642','Brass and White':'#B5A642','Chrome and Clear':'#C0C0C0','Chrome and Frosted White':'#C0C0C0','Chrome and Opal White':'#C0C0C0','Chrome and White':'#C0C0C0','Chrome And White':'#C0C0C0','Chrome And Clear':'#D0D0D0','Satin Gold and Black':'#bd945b','Satin Gold and Clear':'#bd945b','Satin Gold and Frosted White':'#bd945b','Satin Gold and Frosted white':'#bd945b','Satin Gold and Opal White':'#bd945b','Satin Gold and White':'#bd945b','White':'#fff','Matte White':'#F5F5F5','Glossy White':'#FAFAFA','Glossy white':'#FAFAFA','Antique White':'#FAEBD7','Ivory':'#FFFFF0','Ivory White':'#FFFFF0','Linen White':'#FAF0E6','Marble White':'#F5F5F5','Frosted White':'#F0F0F0','frosted white':'#F0F0F0','White paint':'#fff','Opal white':'#F0F0F0','Melamint white':'#F5F5F5','Weathered White and Black':'#E8E0D8','White and Black':'#fff','White and Gold':'#fff','Cararra White':'#F5F0EB','Carrara White':'#F5F0EB','Carrara White Marble':'#F5F0EB','Calacatta White':'#F5F0EB','Calacatta Gold':'#F5F0EB','Calacatta Quartz':'#F5F0EB','Cashmere white granite':'#E8E0D8','Guangxi White Marble':'#F0EBE3','Ivory White Quartz':'#F5F0E8','Blue':'#4A6FA5','Matte Blue':'#4A6FA5','Dark Blue':'#1B3A6B','Melamint Blue':'#6B9BC3','Crystal Cobalt Blue':'#0047AB','Crystal Sky Blue':'#87CEEB','Antique Blue':'#3A5F77','Grey Blue':'#6B8BA4','Green':'#5B8C5A','Matte Green':'#5B8C5A','Dark Green':'#2E5E3E','Melamint Green':'#7DB87D','Crystal Green':'#50C878','Crystal Mint':'#98D4BB','Vintage Mint':'#98D4BB','Brown':'#6B4E37','Dark brown':'#4A3228','Dark Copper Brown':'#5C3317','Mocha Brown':'#6B4226','Honey Brown':'#B08040','Chestnut Brown':'#6F4E37','Walnut Brown':'#5C4033','Brandy Walnut':'#87674F','Brown and Black':'#4A3228','Walnut':'#5C4033','Dark Walnut':'#3E2723','Matte Walnut':'#5C4033','Walnut Oak':'#5C4033','Walnut oak':'#5C4033','Natural':'#C4A882','Natural Wood':'#B08D57','Natural Oak':'#C4A882','Natural Driftwood':'#B8A88A','Teak':'#8B6914','Matte Teak':'#8B6914','Honey Teak':'#C9A96E','Teak-1':'#8B6914','Teak-2':'#7A5E10','Light Teak':'#C9A96E','Honey Oak':'#C9A96E','Honey oak':'#C9A96E','Maple':'#C4956A','Matte Maple':'#C4956A','Melamint Maple':'#C4956A','Cognac':'#834A22','Matte Cognac':'#834A22','Antique Coffee':'#6B4226','Espresso':'#3C1414','Expresso':'#3C1414','Driftwood':'#B8A88A','Driftwood Oak':'#B8A88A','Driftwood oak':'#B8A88A','Linen Oak':'#D4C4A8','Linen oak':'#D4C4A8','Hazel Oak':'#8B7355','Hickory Oak':'#A0804E','Hickory oak':'#A0804E','Olive Oak':'#7D8B5E','Pearl Oak':'#D4C8B8','Chestnut Oak':'#6F4E37','Chestnut Wood':'#6F4E37','Chocolate Oak':'#4A3728','Bright Natural Oak':'#D4B896','Shadow Oak Grey':'#7A7A6E','Shadow oak Grey':'#7A7A6E','Fossil Oak Grey':'#8A8A7A','Fossil oak Grey':'#8A8A7A','Weathered Oak':'#A89880','Weathered Brown':'#6B4E37','Melamint Walnut':'#5C4033','Melamint Teak':'#8B6914','Mango Wood and Black':'#A0804E','mango wood':'#A0804E','Grey':'#999','Gray':'#999','Light Grey':'#C0C0C0','Medium Grey':'#888','Ash Grey':'#B2BEB5','Fog Grey':'#C0C0C0','Pearl Grey':'#C8C0B8','Stone Grey':'#8A8A7A','Concrete Grey':'#999','Weathered Grey':'#8B8378','Melamint Light Gray':'#C8C0B8','Gradient Blue Grey':'#8899AA','Red':'#C0392B','Pink':'#FFB6C1','Amber':'#FFBF00','Yellow':'#FFD700','Vintage Black':'#2A2A2A','Weathered Black':'#333','Jet (Black)':'#000','Beige':'#D4C4A8','Antique Beige':'#C8B89A','light antique beige':'#C8B89A','Antique Gold':'#C5A55A','Antique Gold Leaf':'#C5A55A','Hand Rubbed Antique Gold':'#B8963E','Hand rubbed antique gold':'#B8963E','Smoke':'#808080','Clear':'#E8E8E8','Clear Glass':'#E8E8E8','Cream Marble':'#F5F0E8','Nero Marquina':'#1a1a1a','Weathered Dove':'#B8A8A0','Chevron':'#C4B89A','LED Mirror':'#E0E8F0','Silver Chrome':'#C8C8C8','Gold Chrome':'#C5A55A','Dark Brown Granite':'#3E2723','Black Granite':'#1a1a1a','Black w/ Backsplash':'#000','Blue w/ Backsplash':'#4A6FA5','Green w/ Backsplash':'#5B8C5A','Grey w/ Backsplash':'#999','White w/ Backsplash':'#fff','Dark Walnut w/ Backsplash':'#3E2723','Matte Blue w/ Backsplash':'#4A6FA5','Matte Green w/ Backsplash':'#5B8C5A','Matte Teak w/ Backsplash':'#8B6914','Matte Walnut w/ Backsplash':'#5C4033','Matte White w/ Backsplash':'#F5F5F5','Matte Maple w/ Backsplash':'#C4956A','Matte Cognac w/ Backsplash':'#834A22','Natural w/ Backsplash':'#C4A882','Natural Wood w/ Backsplash':'#B08D57','Weathered Brown w/ Backsplash':'#6B4E37','CO w/ Backsplash':'#834A22','EX w/ Backsplash':'#C9A96E','HO w/ Backsplash':'#B08D57','LO w/ Backsplash':'#C9A96E','BK':'#000','BL':'#4A6FA5','BLK':'#000','BLA':'#000','WH':'#fff','GR':'#999','GN':'#5B8C5A','BR':'#B5A642','BRA':'#B5A642','CH':'#C0C0C0','SG':'#bd945b','SDG':'#bd945b','SN':'#9C9C9C','ORB':'#3B2A1A','RG':'#B76E79','SC':'#C0C0C0','SL':'#BEBEBE','GL':'#D4AF37','GB':'#6B8BA4','PE':'#96A0A0','AI':'#A8A8A8','AW':'#FAEBD7','BG':'#C4A882','BGD':'#C5A55A','BRB':'#6D5C41','BRD':'#6D5C41','BRK':'#1a1a1a','BW':'#333','BWD':'#333','CO':'#834A22','DRG':'#8B8378','EX':'#C9A96E','HO':'#B08D57','HT':'#8B7355','LO':'#C9A96E','RD':'#8B4513','WD':'#5C4033','WG':'#A8A8A8','WOK':'#5C4033','S':'#BEBEBE','B':'#000','ASL':'#A8A8A8','DEX':'#C9A96E','DHO':'#6B4E37','DLO':'#8B6914','DCO':'#6B4226','0BK':'#000','0BL':'#4A6FA5','0DW':'#3E2723','0GN':'#5B8C5A','0GR':'#999','0MBL':'#4A6FA5','0MCG':'#834A22','0MGN':'#5B8C5A','0MMP':'#C4956A','0MTK':'#8B6914','0MWH':'#F5F5F5','0MWT':'#5C4033','0NW':'#B08D57','0WB':'#6B4E37','0WH':'#fff','0MBL w/ Backsplash':'#4A6FA5','0MCG w/ Backsplash':'#834A22','0MGN w/ Backsplash':'#5B8C5A','0MMP w/ Backsplash':'#C4956A','0MTK w/ Backsplash':'#8B6914','0MWH w/ Backsplash':'#F5F5F5','0MWT w/ Backsplash':'#5C4033','0WB w/ Backsplash':'#6B4E37','MCB':'#834A22','MCB w/ Backsplash':'#834A22','MHB':'#B08D57','MHB w/ Backsplash':'#B08D57','MMB':'#5C4033','MMB w/ Backsplash':'#5C4033','DMCB':'#834A22','DMMB':'#5C4033','DMHB':'#B08D57','Black and White Shade':'#333','Black And White Shade':'#333','Aged Brass':'#9C7A3C','Snow White':'#FAFAFA','Honey':'#C9963C','Oak':'#C4A06A','Black Glass':'#2A2A2A','Blue Glass':'#5A7FB5','Gray Glass':'#A8A8A8','Honey Glass':'#D4A858','Ivory White Glass':'#F5F0E0','Oak Glass':'#D0B080','Snow White Glass':'#F0F0F0','Walnut Glass':'#6B4F3F'};
  var MAX_DOTS = 5;
  var MAX_SIZES = 4;

  // Bathroom-vanities now render like every other PLP (Anthony 2026-07-01):
  // colors, sizes, stock/incoming qty, "products" count — same as the lights.
  // Was a special "browse by finish" mode (uncapped swatches, hidden size row,
  // hidden stock, no crossed-out/OOS styling, "collections" label). To restore
  // that mode, swap `false` back to:
  //   /^\/collections\/bathroom-vanities(?:\/|$|\?)/i.test(location.pathname + location.search)
  var IS_VANITIES_PAGE = false;
  if (IS_VANITIES_PAGE) {
    MAX_DOTS = Infinity;
  }
  var processedCards = new WeakSet();
  var familiesData = null;
  var handleIndex = null; // handle → family key

  function log(msg) { console.log('[PFS]', msg); }

  function formatMoney(cents) {
    // B2B repricing happens in swapCard via the captured tier ratio (2026-06-11);
    // this is a plain formatter so the struck-through list price stays retail.
    return '$' + (cents / 100).toFixed(2);
  }

  // ─── Load families.json with sessionStorage cache ───

  function loadFamilies(callback) {
    try {
      var cached = sessionStorage.getItem('pfs_families');
      if (cached) {
        var obj = JSON.parse(cached);
        if (obj.url === FAMILIES_URL) {
          familiesData = obj.data;
          buildHandleIndex();
          log('loaded families from cache (' + Object.keys(familiesData).length + ' families)');
          callback();
          return;
        }
      }
    } catch(e) {}

    fetch(FAMILIES_URL)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        familiesData = data;
        buildHandleIndex();
        log('fetched families (' + Object.keys(familiesData).length + ' families)');
        try {
          sessionStorage.setItem('pfs_families', JSON.stringify({ url: FAMILIES_URL, data: data }));
        } catch(e) { log('sessionStorage full, skipping cache'); }
        callback();
      })
      .catch(function(e) {
        log('failed to load families.json: ' + e.message);
        document.querySelectorAll('.product-card').forEach(function(c) { c.classList.add('pfs-ready'); });
      });
  }

  function buildHandleIndex() {
    try {
      var cached = sessionStorage.getItem('pfs_handleIndex');
      if (cached) {
        var obj = JSON.parse(cached);
        if (obj.url === FAMILIES_URL) { handleIndex = obj.data; return; }
      }
    } catch(e) {}

    handleIndex = {};
    Object.keys(familiesData).forEach(function(fam) {
      var members = familiesData[fam].m;
      Object.keys(members).forEach(function(h) {
        handleIndex[h] = fam;
      });
    });
    try { sessionStorage.setItem('pfs_handleIndex', JSON.stringify({url: FAMILIES_URL, data: handleIndex})); } catch(e) {}
  }

  // ─── Card helpers ───

  function getHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  // Build a product URL that preserves the current collection context (so the PDP
  // breadcrumb resolves to the source collection instead of the product's primary).
  // Mirrors Liquid's `product.url | within: collection`. On non-collection pages
  // returns a bare /products/<handle> URL.
  function productUrl(handle) {
    var m = location.pathname.match(/^\/collections\/([^\/]+)/);
    if (m && m[1] !== 'all') return '/collections/' + m[1] + '/products/' + handle;
    return '/products/' + handle;
  }

  function swapCard(card, targetHandle, targetImage, targetAvailable, targetPrice, targetCompareAt, targetQty) {
    var links = card.querySelectorAll('a[href*="/products/"]');
    var newUrl = productUrl(targetHandle);
    // Closeout flag belongs to the server-rendered product; hide it while another finish is shown
    var closeoutFlag = card.querySelector('.efl-closeout');
    if (closeoutFlag) closeoutFlag.hidden = closeoutFlag.dataset.handle !== targetHandle;
    links.forEach(function(l) { l.href = newUrl; });

    // Update product title to match the new SKU
    var title = card.querySelector('.product-card__title');
    if (title) {
      var titleLink = title.querySelector('a') || title;
      titleLink.textContent = targetHandle.toUpperCase();
    }

    // Update pricing
    if (typeof targetPrice === 'number') {
      var priceContainer = card.querySelector('.f-price');
      if (priceContainer) {
        var priceCents = Math.round(targetPrice * 100);
        var compareCents = targetCompareAt ? Math.round(targetCompareAt * 100) : 0;
        var onSale = compareCents > priceCents;
        if (window.EFL_B2B) {
          // B2B cards show the buyer's tier price with the wholesale list
          // struck through. Both are ratios of retail captured from the
          // server-rendered card (saleRatio = tier, crossRatio = list, which
          // is retail/3 in the wholesale model). Without this, hovering a
          // variant wiped the crossout (reported 2026-06-11).
          var saleRatio = parseFloat(card.dataset.eflRatio);
          var crossRatio = parseFloat(card.dataset.eflCrossRatio);
          if (!(saleRatio > 0 && saleRatio <= 1)) saleRatio = 1 / 3;
          if (!(crossRatio > 0 && crossRatio <= 1)) crossRatio = 1 / 3;
          compareCents = Math.round(priceCents * crossRatio); // list -> crossout
          priceCents = Math.round(priceCents * saleRatio);    // tier -> shown
          onSale = compareCents > priceCents;
        }

        if (onSale) {
          priceContainer.classList.add('f-price--on-sale');
        } else {
          priceContainer.classList.remove('f-price--on-sale');
        }

        // Update sale price
        var saleItem = priceContainer.querySelector('.f-price__sale .f-price-item--sale');
        if (saleItem) {
          saleItem.textContent = onSale ? formatMoney(priceCents) : '';
        }

        // Update compare-at (strikethrough) price in sale section
        var saleRegular = priceContainer.querySelector('.f-price__sale .f-price-item--regular');
        if (saleRegular) {
          var s = saleRegular.querySelector('s');
          if (s) {
            s.textContent = onSale ? formatMoney(compareCents) : '';
          }
        }

        // Update regular price (shown when not on sale)
        var regItem = priceContainer.querySelector('.f-price__regular .f-price-item--regular');
        if (regItem) {
          regItem.textContent = onSale ? '' : formatMoney(priceCents);
        }
      }
    }

    // Update sold-out badge + ATC button based on availability
    if (typeof targetAvailable !== 'undefined') {
      var soldBadge = card.querySelector('.f-badge--soldout');
      var badgeContainer = card.querySelector('.product-card__badge');
      var imgWrapper = card.querySelector('.product-card__image-wrapper');
      var atcBtn = card.querySelector('.product-card__atc');
      var atcText = card.querySelector('.product-card__atc-text');
      var variantInput = card.querySelector('.product-variant-id');

      if (targetAvailable === false) {
        if (!badgeContainer && imgWrapper) {
          badgeContainer = document.createElement('div');
          badgeContainer.className = 'product-card__badge';
          imgWrapper.appendChild(badgeContainer);
        }
        if (!soldBadge && badgeContainer) {
          var newBadge = document.createElement('span');
          newBadge.className = 'f-badge f-badge--soldout';
          newBadge.textContent = 'Sold out';
          badgeContainer.appendChild(newBadge);
        } else if (soldBadge) {
          soldBadge.style.display = '';
        }
        if (atcBtn) { atcBtn.disabled = true; atcBtn.classList.add('pfs-soldout'); }
        if (atcText) atcText.textContent = 'Sold out';
        if (variantInput) variantInput.disabled = true;
      } else {
        if (soldBadge) soldBadge.style.display = 'none';
        if (atcBtn) { atcBtn.disabled = false; atcBtn.classList.remove('pfs-soldout'); }
        if (atcText) atcText.textContent = 'Add to cart';
        if (variantInput) variantInput.disabled = false;
      }
    }

    if (targetImage) {
      var imgWrapper = card.querySelector('.product-card__image--main');
      var img = imgWrapper ? imgWrapper.querySelector('img') : card.querySelector('img');
      if (img) {
        img.style.transition = 'opacity .2s ease';
        img.style.opacity = '0';
        setTimeout(function() {
          img.src = targetImage;
          img.srcset = targetImage.replace('width=600','width=300') + ' 300w, ' + targetImage + ' 600w, ' + targetImage.replace('width=600','width=900') + ' 900w';
          img.style.objectFit = 'contain';
          img.style.objectPosition = 'center';
          img.style.width = '100%';
          img.style.height = '100%';
          img.style.opacity = '1';
        }, 150);
      }
    }

    // Update stock count under price (rendered by snippets/pcard-stock.liquid).
    var stockEl = card.querySelector('.pcard-stock');
    if (stockEl) {
      var qtyEl = stockEl.querySelector('.pcard-stock__qty');
      var textEl = stockEl.querySelector('.pcard-stock__text');
      stockEl.classList.remove('pcard-stock--in', 'pcard-stock--out');
      if (typeof targetQty === 'number' && targetQty > 0) {
        if (!qtyEl) {
          qtyEl = document.createElement('strong');
          qtyEl.className = 'pcard-stock__qty';
          qtyEl.style.color = 'rgb(var(--color-foreground))';
          qtyEl.style.fontWeight = '600';
          stockEl.insertBefore(qtyEl, stockEl.firstChild);
          stockEl.insertBefore(document.createTextNode(' '), qtyEl.nextSibling);
        }
        qtyEl.textContent = targetQty;
        if (textEl) textEl.textContent = 'in stock';
        stockEl.classList.add('pcard-stock--in');
        stockEl.style.color = 'rgba(var(--color-foreground),.65)';
      } else if (targetAvailable === false) {
        if (qtyEl) qtyEl.remove();
        if (textEl) textEl.textContent = 'Out of stock';
        stockEl.classList.add('pcard-stock--out');
        stockEl.style.color = '#a5a4ab';
      } else {
        if (qtyEl) qtyEl.remove();
        if (textEl) textEl.textContent = 'In stock';
        stockEl.classList.add('pcard-stock--in');
        stockEl.style.color = 'rgba(var(--color-foreground),.65)';
      }
    }
  }

  // ─── Swatch injection with finish×size cross-reference ───

  // Cabinet line prefixes leak into families.json as raw codes (e.g.
  // "IWSK1-DSB36"). Normalize to customer-facing finish names.
  var FINISH_LABELS = { IWSK: 'Ivory White', HYSK: 'Honey', GRSK: 'Grey', WHSK: 'White', SKGR: 'Grey', SKWH: 'White' };
  function finishLabel(f) {
    if (!f) return f;
    var m = /^([A-Z]{2,4})(?:SK)?\d*-/.exec(f) || /^([A-Z]{4,6})\d*-/.exec(f);
    if (m) {
      var key = m[1].length <= 2 ? m[1] + 'SK' : m[1];
      if (FINISH_LABELS[key]) return FINISH_LABELS[key];
    }
    for (var k in FINISH_LABELS) { if (f.indexOf(k) === 0) return FINISH_LABELS[k]; }
    return f;
  }

  function injectSwatches(card, handle, family) {
    if (card.querySelector('.pcard-swatches')) return;

    var members = family.m;
    var me = members[handle];
    if (!me) return;

    // Mutable state — tracks current finish/size as user clicks swatches
    var state = { finish: me.f, size: me.s };

    // Build unique finishes and sizes
    var finishSet = {};
    var sizeSet = {};
    Object.keys(members).forEach(function(h) {
      var m = members[h];
      if (!finishSet[m.f]) finishSet[m.f] = [];
      finishSet[m.f].push(h);
      if (!sizeSet[m.s]) sizeSet[m.s] = [];
      sizeSet[m.s].push(h);
    });

    var finishKeys = Object.keys(finishSet);
    var sizeKeys = Object.keys(sizeSet).sort(function(a, b) {
      var na = parseFloat(a), nb = parseFloat(b);
      if (!isNaN(na) && !isNaN(nb)) return na - nb;
      return a.localeCompare(b);
    });

    if (finishKeys.length < 2 && sizeKeys.length < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'pcard-swatches';
    var finishRow = null;
    var sizeRow = null;

    function getSwapData(a) {
      var h = a.getAttribute('data-handle');
      var td = members[h];
      return {
        handle: h,
        image: a.getAttribute('data-image'),
        avail: a.getAttribute('data-avail') !== 'false',
        price: td ? td.p : undefined,
        compareAt: td ? td.cp : undefined,
        qty: td && typeof td.q === 'number' ? td.q : undefined
      };
    }

    // Helper: update swatch targets after state change
    function updateSwatchTargets() {
      var _cur = findMember(members, state.finish, state.size);
      if (sizeRow) {
        sizeRow.querySelectorAll('.pcard-swatch--size').forEach(function(a) {
          var sz = a.getAttribute('data-size');
          var target = findMember(members, state.finish, sz, undefined, _cur) || sizeSet[sz][0];
          var td = members[target];
          a.setAttribute('data-handle', target);
          a.setAttribute('data-image', td ? td.i : '');
          a.setAttribute('data-avail', td ? String(td.a !== false) : 'true');
          a.href = productUrl(target);
          if (IS_VANITIES_PAGE || findMember(members, state.finish, sz)) {
            a.classList.remove('pcard-swatch--unavail');
          } else {
            a.classList.add('pcard-swatch--unavail');
          }
          if (!IS_VANITIES_PAGE && td && td.a === false) {
            a.classList.add('pcard-swatch--oos');
          } else {
            a.classList.remove('pcard-swatch--oos');
          }
        });
      }
      if (finishRow) {
        finishRow.querySelectorAll('.pcard-swatch--color').forEach(function(a) {
          var fn = a.getAttribute('data-finish');
          var target = findMember(members, fn, state.size, undefined, _cur) || finishSet[fn][0];
          var td = members[target];
          a.setAttribute('data-handle', target);
          a.setAttribute('data-image', td ? td.i : '');
          a.setAttribute('data-avail', td ? String(td.a !== false) : 'true');
          a.href = productUrl(target);
          if (IS_VANITIES_PAGE || findMember(members, fn, state.size)) {
            a.classList.remove('pcard-swatch--unavail');
          } else {
            a.classList.add('pcard-swatch--unavail');
          }
          if (!IS_VANITIES_PAGE && td && td.a === false) {
            a.classList.add('pcard-swatch--oos');
          } else {
            a.classList.remove('pcard-swatch--oos');
          }
        });
      }
    }

    // ─── Finish row ───
    // Capture the card's initial state so we can restore on mouseleave after
    // a hover preview. Color swatches now navigate on click (no preventDefault)
    // and only preview on hover.
    var initialMember = members[handle] || me;
    // B2B: the server-rendered price reflects the customer's tier (level /
    // insider / wholesale). Capture displayedPrice / retailPrice once so hover
    // swaps can reprice any member with the same tier math instead of a
    // hard-coded divisor — and keep the struck-through list price intact.
    if (window.EFL_B2B && initialMember && typeof initialMember.p === 'number' && !card.dataset.eflRatio) {
      var saleEl = card.querySelector('.f-price__sale .f-price-item--sale') ||
                   card.querySelector('.f-price__regular .f-price-item--regular');
      var crossEl = card.querySelector('.f-price__sale .f-price-item--regular s');
      var shown = saleEl ? parseFloat((saleEl.textContent || '').replace(/[^0-9.]/g, '')) : NaN;
      var crossShown = crossEl ? parseFloat((crossEl.textContent || '').replace(/[^0-9.]/g, '')) : NaN;
      if (shown > 0 && initialMember.p > 0) {
        card.dataset.eflRatio = String(shown / initialMember.p);
      }
      if (crossShown > 0 && initialMember.p > 0) {
        card.dataset.eflCrossRatio = String(crossShown / initialMember.p);
      }
    }
    var initialData = {
      handle: handle,
      image: initialMember ? initialMember.i : '',
      avail: initialMember ? initialMember.a !== false : true,
      price: initialMember ? initialMember.p : undefined,
      compareAt: initialMember ? initialMember.cp : undefined,
      qty: initialMember && typeof initialMember.q === 'number' ? initialMember.q : undefined
    };

    if (finishKeys.length > 1) {
      finishRow = document.createElement('div');
      finishRow.className = 'pcard-swatches__row';
      var count = 0;
      var displayFinishes = finishKeys;
      if (finishKeys.indexOf(state.finish) >= MAX_DOTS) {
        displayFinishes = finishKeys.slice(0, MAX_DOTS - 1).concat([state.finish]);
      }
      displayFinishes.forEach(function(finish) {
        if (count >= MAX_DOTS) return;
        var hex = FINISH_HEX[finish] || '#888';
        var active = finish === state.finish;
        var exactMatch = findMember(members, finish, state.size);
        var target = exactMatch || finishSet[finish][0];
        var targetData = members[target];
        var unavail = !exactMatch;
        var oos = targetData && targetData.a === false;

        var a = document.createElement('a');
        a.href = productUrl(target);
        a.className = 'pcard-swatch pcard-swatch--color' + (active ? ' pcard-swatch--active' : '') + (!IS_VANITIES_PAGE && unavail ? ' pcard-swatch--unavail' : '') + (!IS_VANITIES_PAGE && oos && !unavail ? ' pcard-swatch--oos' : '');
        a.title = finish + (unavail ? ' (not available in this size)' : '');
        a.setAttribute('data-handle', target);
        a.setAttribute('data-image', targetData ? targetData.i : '');
        a.setAttribute('data-finish', finish);
        a.setAttribute('data-avail', targetData ? String(targetData.a !== false) : 'true');
        a.onmouseenter = function() {
          // cross-size targets still preview their member (closeout families are sparse)
          var d = getSwapData(a);
          swapCard(card, d.handle, d.image, d.avail, d.price, d.compareAt, d.qty);
        };
        a.onmouseleave = function() {
          swapCard(card, initialData.handle, initialData.image, initialData.avail, initialData.price, initialData.compareAt, initialData.qty);
        };
        a.onclick = function(e) {
          // Swatches always navigate — "unavailable in this size" targets the
          // nearest member in another size (its href), which is what closeout
          // shoppers need. Only block if there is genuinely no target.
          if (!a.getAttribute('data-handle')) { e.preventDefault(); e.stopPropagation(); }
        };
        var dot = document.createElement('span');
        dot.className = 'pcard-swatch__dot';
        dot.style.backgroundColor = hex;
        if (finish === 'White' || finish === 'Matte White' || finish === 'Glossy White' || finish === 'Antique White')
          dot.style.border = '1px solid #ccc';
        a.appendChild(dot);
        finishRow.appendChild(a);
        count++;
      });
      if (finishKeys.length > MAX_DOTS) {
        var more = document.createElement('a');
        more.className = 'pcard-swatch-more';
        more.href = productUrl(handle);
        more.textContent = '+' + (finishKeys.length - MAX_DOTS);
        finishRow.appendChild(more);
      }
      wrap.appendChild(finishRow);
    }

    // ─── Size row ───
    // Hide size swatches on the Bathroom Vanities collection (sizes are
    // confusing on width-based vanities — finish-only is cleaner).
    if (sizeKeys.length > 1 && !IS_VANITIES_PAGE) {
      sizeRow = document.createElement('div');
      sizeRow.className = 'pcard-swatches__row pcard-swatches__row--size';
      // LxH sizes (e.g. "18x30\"") are wider than plain sizes — cap at 3 to avoid wrap
      var isLxH = sizeKeys.some(function(s){ return /\d+\s*[xX×]\s*\d+/.test(s); });
      var sizeCap = isLxH ? 3 : MAX_SIZES;
      var sCount = 0;
      // The selected size must always be visible, even when it sorts past the
      // cap (a 60" preselected card would otherwise show no highlighted chip).
      var displaySizes = sizeKeys;
      if (sizeKeys.indexOf(state.size) >= sizeCap) {
        displaySizes = sizeKeys.slice(0, sizeCap - 1).concat([state.size]);
      }
      displaySizes.forEach(function(size) {
        if (sCount >= sizeCap) return;
        var active = size === state.size;
        var exactMatch = findMember(members, state.finish, size);
        var target = exactMatch || sizeSet[size][0];
        var targetData = members[target];
        var unavail = !exactMatch;
        var oos = targetData && targetData.a === false;

        var a = document.createElement('a');
        a.href = productUrl(target);
        a.className = 'pcard-swatch pcard-swatch--size' + (active ? ' pcard-swatch--active' : '') + (!IS_VANITIES_PAGE && unavail ? ' pcard-swatch--unavail' : '') + (!IS_VANITIES_PAGE && oos && !unavail ? ' pcard-swatch--oos' : '');
        a.textContent = size;
        a.setAttribute('data-handle', target);
        a.setAttribute('data-image', targetData ? targetData.i : '');
        a.setAttribute('data-size', size);
        a.setAttribute('data-avail', targetData ? String(targetData.a !== false) : 'true');
        a.onmouseenter = function() {
          // cross-size targets still preview their member (closeout families are sparse)
          var d = getSwapData(a);
          swapCard(card, d.handle, d.image, d.avail, d.price, d.compareAt, d.qty);
        };
        a.onmouseleave = function() {
          swapCard(card, initialData.handle, initialData.image, initialData.avail, initialData.price, initialData.compareAt, initialData.qty);
        };
        a.onclick = function(e) {
          // Swatches always navigate — "unavailable in this size" targets the
          // nearest member in another size (its href), which is what closeout
          // shoppers need. Only block if there is genuinely no target.
          if (!a.getAttribute('data-handle')) { e.preventDefault(); e.stopPropagation(); }
        };
        sizeRow.appendChild(a);
        sCount++;
      });
      if (sizeKeys.length > sizeCap) {
        var more2 = document.createElement('a');
        more2.className = 'pcard-swatch-more';
        more2.href = productUrl(handle);
        more2.textContent = '+' + (sizeKeys.length - sizeCap);
        sizeRow.appendChild(more2);
      }
      wrap.appendChild(sizeRow);
    }

    // Prefetch a few sibling images
    var prefetched = 0;
    Object.keys(members).forEach(function(h) {
      if (prefetched >= 10) return;
      if (h !== handle && members[h].i) {
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = members[h].i;
        link.as = 'image';
        document.head.appendChild(link);
        prefetched++;
      }
    });

    var info = card.querySelector('.product-card__info');
    if (info) {
      var title = info.querySelector('.product-card__title');
      if (title) title.after(wrap);
      else info.prepend(wrap);
    }
  }

  // findMember(members, finish, size [, backsplash])
  // When backsplash is true/false, prefers a member matching all three dimensions
  // — so e.g. the PDP "With Backsplash" toggle stays on when the customer flips
  // finish or size. Falls back to a 2-dim match if no triple match exists.
  function findMember(members, finish, size, backsplash, prefHandle) {
    var keys = Object.keys(members), matches = [], i, m;
    if (backsplash !== undefined) {
      for (i = 0; i < keys.length; i++) {
        m = members[keys[i]];
        if (m.f === finish && m.s === size && (!!m.b) === !!backsplash) matches.push(keys[i]);
      }
    }
    if (!matches.length) {
      for (i = 0; i < keys.length; i++) {
        m = members[keys[i]];
        if (m.f === finish && m.s === size) matches.push(keys[i]);
      }
    }
    if (!matches.length) return null;
    // On a (finish,size) collision across distinct model lines (e.g. mr1b vs
    // mr1fl, mr6a vs mr6e), prefer the candidate sharing the longest leading
    // prefix with the current product so a swatch click stays on the same model.
    if (matches.length > 1 && prefHandle) {
      var best = matches[0], bestLen = -1;
      for (i = 0; i < matches.length; i++) {
        var a = matches[i], n = 0;
        while (n < a.length && n < prefHandle.length && a[n] === prefHandle[n]) n++;
        if (n > bestLen) { bestLen = n; best = matches[i]; }
      }
      return best;
    }
    return matches[0];
  }

  // ─── Preferred-member selection ───
  // Where did the customer express a variation preference?
  //   PLP facets:  filter.p.m.custom.family_sizes / family_finishes (exact values)
  //   Search:      ?q= tokens — a width ("24 inch", 24"), "double sink", finish words
  function eflPreferredTokens() {
    var p = new URLSearchParams(location.search);
    var t = { sizes: [], finishes: [], qNum: null, qDouble: false, q: null };
    p.forEach(function(v, k) {
      if (k === 'filter.p.m.custom.family_sizes') t.sizes.push(v);
      if (k === 'filter.p.m.custom.family_finishes') t.finishes.push(v);
    });
    if (location.pathname.indexOf('/search') === 0) {
      var q = (p.get('q') || '').replace(/\*+$/, '').toLowerCase();
      if (q) {
        var m = q.match(/(\d+(?:\.\d+)?)\s*(?:inch(?:es)?|in\b|["\u201d])/);
        if (m) t.qNum = parseFloat(m[1]);
        t.qDouble = /double\s*sink/.test(q);
        t.q = q;
      }
    }
    return (t.sizes.length || t.finishes.length || t.qNum !== null || t.qDouble || t.q)
      ? t : null;
  }

  // Resolve tokens against one family. Returns a member handle to open the
  // card on, or null to leave the card alone.
  //
  // Single- and double-sink members are identical in member data (same s, same
  // f — e.g. vf2860nt / vf2860dnt both s='60"'); the only marker is the 'd'
  // after the width digits in the handle. So width selection works on numbers
  // and disambiguates double-sink by handle pattern, never by findMember.
  function eflIsDoubleHandle(h, num) {
    return new RegExp(String(num) + 'd', 'i').test(h);
  }

  function eflPickByWidth(members, me, num, wantDouble, wantFinish) {
    var best = null, bestScore = -1;
    Object.keys(members).forEach(function(h) {
      var m = members[h];
      if (parseFloat(m.s) !== num) return;
      if (wantDouble !== eflIsDoubleHandle(h, num)) return;
      var score = (wantFinish && m.f === wantFinish ? 4 : (m.f === me.f ? 2 : 0)) +
                  (m.a !== false ? 1 : 0);
      if (score > bestScore) { bestScore = score; best = h; }
    });
    return best;
  }

  function eflPreferredMember(members, meHandle, t) {
    var me = members[meHandle];
    if (!me) return null;
    // NS finish names vary in case ('White' vs 'WHITE' vs 'white') — match
    // case-insensitively and resolve back to the member's actual spelling.
    var finLower = {};
    Object.keys(members).forEach(function(h) {
      finLower[(members[h].f || '').toLowerCase()] = members[h].f;
    });

    // What does the customer want? Facet values and query tokens both reduce
    // to (width number, double?) + finish name.
    var wantNum = null, wantDouble = false, wantFinish = null;
    t.sizes.forEach(function(v) {
      var mm = /^(\d+(?:\.\d+)?)/.exec(v);
      if (mm && wantNum === null) {
        wantNum = parseFloat(mm[1]);
        wantDouble = /double/i.test(v);
      }
    });
    t.finishes.some(function(v) {
      var f = finLower[(v || '').toLowerCase()];
      if (f !== undefined) { wantFinish = f; return true; }
    });
    if (wantNum === null && t.qNum !== null) { wantNum = t.qNum; wantDouble = t.qDouble; }
    if (wantNum === null && t.qDouble) { wantDouble = true; }
    if (!wantFinish && t.q) {
      Object.keys(finLower).forEach(function(fl) {
        if (t.q.indexOf(fl) !== -1 &&
            (!wantFinish || fl.length > wantFinish.length)) wantFinish = finLower[fl];
      });
    }
    if (wantNum === null && !wantDouble && !wantFinish) return null;

    var target = null;
    if (wantNum !== null) {
      target = eflPickByWidth(members, me, wantNum, wantDouble, wantFinish) ||
               eflPickByWidth(members, me, wantNum, !wantDouble, wantFinish);
    } else if (wantDouble) {
      // "double sink" with no width: first double member, preferring my finish
      var bestScore = -1;
      Object.keys(members).forEach(function(h) {
        var num = parseFloat(members[h].s);
        if (isNaN(num) || !eflIsDoubleHandle(h, num)) return;
        var score = (members[h].f === me.f ? 2 : 0) + (members[h].a !== false ? 1 : 0);
        if (score > bestScore) { bestScore = score; target = h; }
      });
    } else if (wantFinish) {
      target = findMember(members, wantFinish, me.s, undefined, meHandle);
      if (!target) {
        Object.keys(members).some(function(h) {
          if (members[h].f === wantFinish) { target = h; return true; }
        });
      }
    }
    return target && target !== meHandle ? target : null;
  }

  // Search results include pf-hidden family members (search ignores collection
  // rules), so one family can appear as several near-identical cards. Collapse
  // to the first card per family; persists across infinite-scroll batches.
  var IS_SEARCH_PAGE = location.pathname.indexOf('/search') === 0;
  var eflSeenFamilies = {};

  // ─── Process all product cards ───

  /* Collection filtering handled server-side */
  var currentPage = (new URLSearchParams(window.location.search)).get('page') || '1';
  if (currentPage === '1') {
    try { sessionStorage.removeItem(storageKey); } catch(e) {}
  } else {
    try {
      var saved = sessionStorage.getItem(storageKey);
      if (saved) shownFamilies = JSON.parse(saved);
    } catch(e) {}
  }

  function processCards() {
    if (!familiesData || !handleIndex) return;

    // Skip swatch injection on dedicated family collection pages — those pages
    // are meant to show every SKU in the family as its own standalone card.
    if (/^\/collections\/(family-|[a-z0-9-]+-collection(\/|$))/.test(location.pathname)) {
      document.querySelectorAll('.product-card').forEach(function(c) { c.classList.add('pfs-ready'); });
      return;
    }

    var tokens = eflPreferredTokens();

    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function(card) {
      if (processedCards.has(card)) return;
      processedCards.add(card);
      var handle = getHandle(card);
      if (!handle) return;
      var famKey = handleIndex[handle];
      if (!famKey) return;
      var family = familiesData[famKey];

      if (IS_SEARCH_PAGE) {
        if (eflSeenFamilies[famKey]) { card.style.display = 'none'; return; }
        eflSeenFamilies[famKey] = true;
      }

      if (Object.keys(family.m).length < 2) return;

      // Open the card on the member the filter/query points at.
      if (tokens) {
        var pref = eflPreferredMember(family.m, handle, tokens);
        if (pref) {
          var td = family.m[pref];
          swapCard(card, pref, td.i, td.a !== false, td.p, td.cp,
                   typeof td.q === 'number' ? td.q : undefined);
          handle = pref;
        }
      }
      injectSwatches(card, handle, family);
    });
  }

  // ─── "N styles · M items" product count (2026-07-21) ───
  // The Shopify-rendered #ProductCount is a single number whose meaning
  // varies by collection shape: on pf-hide PLPs it counts the visible family
  // cards (understates inventory); on closeout it counts every SKU. Both
  // hide "the power of our inventory" (Jim/Anthony 2026-07-21). We show BOTH
  // numbers — styles (distinct families) and items (true SKU total) — from
  // collection_counts.json, precomputed nightly server-side from actual
  // collection membership. The old client-side family-sum guesswork (summed
  // families.json members across rendered cards + a type-extrapolation)
  // produced wrong numbers on mixed collections — closeout showed "294
  // products" for a 1,209-item collection — and was removed.
  // Skipped when a PLP filter is active (Shopify's filtered count is right),
  // and on any page without a counts entry (server count stays untouched).
  var eflCounts = null;
  function updateProductCount() {
    if (eflFiltersActive()) return;
    // Vanities PLP browse-by-finish mode (currently disabled via
    // IS_VANITIES_PAGE=false): relabel only, keep the server count.
    if (IS_VANITIES_PAGE) {
      var elv = document.getElementById('ProductCount');
      if (elv) elv.innerHTML = elv.innerHTML.replace(/\bproducts?\b/i, 'collections');
      return;
    }
    var m = location.pathname.match(/^\/collections\/([^\/]+)\/?$/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    function render() {
      var c = eflCounts && eflCounts[handle];
      if (!c || !(c.s > 0) || !(c.i > c.s)) return;
      var el = document.getElementById('ProductCount');
      if (!el) return;
      var fmt = function(n) { return n.toLocaleString('en-US'); };
      el.textContent = fmt(c.s) + (c.s === 1 ? ' style' : ' styles') +
        ' · ' + fmt(c.i) + (c.i === 1 ? ' item' : ' items');
    }
    if (eflCounts) { render(); return; }
    fetch(COUNTS_URL).then(function(r) { return r.json(); })
      .then(function(d) { eflCounts = d || {}; render(); })
      .catch(function() {});
  }

  // ─── Card type-line size range fill ───
  // The card snippet renders <span class="pcard-size-range" data-handle=...>.
  // For multi-size families we fill it with `{min}" - {max}" ` so the line
  // reads "{collection_name} {min}" - {max}" {product.type}".
  function fillSizeRanges() {
    if (!familiesData || !handleIndex) return;
    document.querySelectorAll('.pcard-size-range[data-handle]').forEach(function(span) {
      if (span.dataset.eflFilled) return;
      span.dataset.eflFilled = '1';
      var handle = span.getAttribute('data-handle');
      var famKey = handleIndex[handle];
      if (!famKey) return;
      var family = familiesData[famKey];
      if (!family) return;
      var nums = [];
      Object.keys(family.m).forEach(function(h) {
        var s = family.m[h].s || '';
        var n = parseFloat(s);
        if (!isNaN(n)) nums.push(n);
      });
      if (nums.length < 2) return;
      var min = Math.min.apply(null, nums);
      var max = Math.max.apply(null, nums);
      if (min === max) return;
      var fmt = function(n) { return (Number.isInteger(n) ? n : n.toFixed(1).replace(/\.0$/, '')) + '"'; };
      span.textContent = fmt(min) + ' - ' + fmt(max) + ' ';
    });
  }

  // ─── Collection-name facet count override ───
  // Shopify facet counts ignore pf-hide products, so "Park Avenue (3)" actually
  // means 3 visible primary cards — but Park Avenue has ~82 SKUs total. Rewrite
  // each facet count from families.json so customers see real SKU totals.
  function rewriteCollectionFacetCounts() {
    if (!familiesData) return;
    var counts = {};
    Object.keys(familiesData).forEach(function(famKey) {
      var collectionName = famKey.split('_')[0];
      counts[collectionName] = (counts[collectionName] || 0) + Object.keys(familiesData[famKey].m).length;
    });
    document.querySelectorAll('input[name="filter.p.m.custom.collection_name"]').forEach(function(input) {
      var val = input.value;
      var total = counts[val];
      if (typeof total !== 'number') return;
      var label = document.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var span = label.querySelector('span.text-subtext') || label.querySelector('span');
      if (span && span.textContent.indexOf('(') !== -1) span.textContent = '(' + total + ')';
    });
  }

  // ─── Per-collection visibility tweaks ───
  // Bathroom vanities: hide the stock count under price (noisy on a B2B vanity
  // page where most variants are made-to-order).
  function applyCollectionTweaks() {
    if (IS_VANITIES_PAGE) {
      var s = document.createElement('style');
      s.textContent = '.pcard-stock{display:none!important}';
      document.head.appendChild(s);
    }
  }

  // ─── Init ───

  function init() {
    applyCollectionTweaks();
    var attempts = 0;
    function tryProcess() {
      var cards = document.querySelectorAll('.product-card');
      if (cards.length > 0) {
        loadFamilies(function() {
          processCards();
          fillSizeRanges();
          updateProductCount();
          rewriteCollectionFacetCounts();
          initPDP();
        });
      } else if (attempts < 20) {
        attempts++;
        setTimeout(tryProcess, 300);
      } else {
        log('no product cards found');
      }
    }
    tryProcess();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Watch for dynamically added cards (infinite scroll)
  new MutationObserver(function() {
    setTimeout(processCards, 100);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  setInterval(processCards, 1000);

  // ─── PDP Swatches ───
  function initPDP() {
    var c = document.getElementById('product-family-swatches');
    if (!c || c.dataset.pfsInit || !familiesData || !handleIndex) return;
    c.dataset.pfsInit = 'true';
    var handle = c.dataset.currentHandle;
    if (!handle) return;
    var fk = handleIndex[handle];
    if (!fk) { c.style.display = 'none'; return; }
    var fam = familiesData[fk];
    var members = fam.m;
    var me = members[handle];
    if (!me) { c.style.display = 'none'; return; }
    var fs = {}, ss = {};
    Object.keys(members).forEach(function(h) {
      var m = members[h];
      if (!fs[m.f]) fs[m.f] = [];
      fs[m.f].push(h);
      if (!ss[m.s]) ss[m.s] = [];
      ss[m.s].push(h);
    });
    var fKeys = Object.keys(fs);
    var sKeys = Object.keys(ss).sort(function(a,b) {
      var na=parseFloat(a),nb=parseFloat(b);
      return (!isNaN(na)&&!isNaN(nb)) ? na-nb : a.localeCompare(b);
    });
    if (fKeys.length < 2 && sKeys.length < 2) { c.style.display='none'; return; }
    var ld = document.getElementById('pfs-loading');
    var ct = document.getElementById('pfs-content');
    if (fKeys.length > 1) {
      var fg = document.getElementById('pfs-finish-group');
      var fc = document.getElementById('pfs-finish-swatches');
      if (fg && fc) {
        fKeys.forEach(function(f) {
          var hex = FINISH_HEX[f] || '#888';
          var active = f === me.f;
          // Preserve backsplash state when switching finish so the BS toggle doesn't deselect
          var target = findMember(members,f,me.s,me.b) || fs[f][0];
          var td = members[target];
          var oos = td && td.a === false;
          var a = document.createElement('a');
          a.href = active ? '#' : productUrl(target);
          a.className = 'pfs-swatch pfs-swatch--color pfs-swatch--name' + (active ? ' pfs-active' : '') + (oos ? ' pfs-swatch--oos' : '');
          if (oos) a.setAttribute('title', f + ' (sold out)');
          if (active) a.addEventListener('click', function(e){e.preventDefault();});
          a.textContent = finishLabel(f);
          fc.appendChild(a);
        });
        fg.style.display = '';
      }
    }
    if (sKeys.length > 1) {
      var sg = document.getElementById('pfs-size-group');
      var sc = document.getElementById('pfs-size-swatches');
      if (sg && sc) {
        sKeys.forEach(function(s) {
          var active = s === me.s;
          // Preserve backsplash state when switching size
          var target = findMember(members,me.f,s,me.b) || ss[s][0];
          var td = members[target];
          var oos = td && td.a === false;
          var a = document.createElement('a');
          a.href = active ? '#' : productUrl(target);
          a.className = 'pfs-swatch pfs-swatch--size' + (active ? ' pfs-active' : '') + (oos ? ' pfs-swatch--oos' : '');
          a.textContent = s;
          if (oos) a.setAttribute('title', s + ' (sold out)');
          if (active) a.addEventListener('click', function(e){e.preventDefault();});
          sc.appendChild(a);
        });
        sg.style.display = '';
      }
    }
    // ─── Backsplash row (vanity-only, when family has both with and without) ───
    var hasBS = false, hasNoBS = false;
    Object.keys(members).forEach(function(h){ if (members[h].b) hasBS = true; else hasNoBS = true; });
    if (hasBS && hasNoBS) {
      var bg = document.getElementById('pfs-backsplash-group');
      var bc = document.getElementById('pfs-backsplash-swatches');
      if (bg && bc) {
        var meHasBS = !!me.b;
        [
          { label: 'Without', want: false },
          { label: 'With Backsplash', want: true }
        ].forEach(function(opt) {
          // Find a sibling matching current finish + size + desired backsplash state
          var target = null;
          Object.keys(members).forEach(function(h) {
            if (target) return;
            var m = members[h];
            if (m.f === me.f && m.s === me.s && (!!m.b) === opt.want) target = h;
          });
          // Fallback: any member with matching backsplash state
          if (!target) {
            Object.keys(members).forEach(function(h) {
              if (target) return;
              if ((!!members[h].b) === opt.want) target = h;
            });
          }
          if (!target) return;
          var td = members[target];
          var active = (opt.want === meHasBS);
          var oos = td && td.a === false;
          var a = document.createElement('a');
          a.href = active ? '#' : productUrl(target);
          a.className = 'pfs-swatch pfs-swatch--size' + (active ? ' pfs-active' : '') + (oos ? ' pfs-swatch--oos' : '');
          a.textContent = opt.label;
          if (active) a.addEventListener('click', function(e){e.preventDefault();});
          bc.appendChild(a);
        });
        bg.style.display = '';
      }
    }
    if (ld) ld.style.display = 'none';
    if (ct) ct.style.display = '';
    c.style.display = '';
    var btn = document.querySelector('.product__block--quantity_selector, .product-form__buttons, .product__block--buy_buttons');
    if (btn) btn.parentNode.insertBefore(c, btn);
  }

  // PDP retry
  setTimeout(function() {
    var c = document.getElementById('product-family-swatches');
    if (c && !c.dataset.pfsInit) {
      try { sessionStorage.removeItem('pfs_families'); } catch(e) {}
      try { sessionStorage.removeItem('pfs_handleIndex'); } catch(e) {}
      loadFamilies(function() {
        processCards();
        initPDP();
      });
    }
  }, 3000);
})();
